// import { useState, useCallback } from "react";

// // Generate random 4-digit alphanumeric string
// const generateCode = () => {
//   const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
//   let code = "";
//   for (let i = 0; i < 4; i++) {
//     code += chars[Math.floor(Math.random() * chars.length)];
//   }
//   return code;
// };

// export function Captcha({ onVerified }) {
//   const [code, setCode]     = useState(() => generateCode());
//   const [input, setInput]   = useState("");
//   const [error, setError]   = useState("");
//   const [success, setSuccess] = useState(false);

//   const refresh = useCallback(() => {
//     setCode(generateCode());
//     setInput("");
//     setError("");
//     setSuccess(false);
//     onVerified?.(false);
//   }, [onVerified]);

//   const validate = () => {
//     if (!input) {
//       setError("Please enter the code.");
//       return;
//     }
//     if (input.toUpperCase() === code) {
//       setError("");
//       setSuccess(true);
//       onVerified?.(true);
//     } else {
//       setError("Invalid code. Please try again.");
//       setSuccess(false);
//       onVerified?.(false);
//       setCode(generateCode());
//       setInput("");
//     }
//   };

//   return (
//     <div style={styles.wrapper}>

//       {/* CAPTCHA code box + input + verify all in one flex row */}
//       <div style={styles.row}>

//         {/* Code display box */}
//         <div style={styles.codeBox}>
//           <span style={styles.codeText}>{code}</span>
//           <button
//             type="button"
//             onClick={refresh}
//             style={styles.refreshBtn}
//             title="Refresh CAPTCHA"
//           >
//             <svg
//               width="18"
//               height="18"
//               viewBox="0 0 12 12"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M10 2.5A5 5 0 1 0 11 6"
//                 stroke="#555"
//                 strokeWidth="1.5"
//                 strokeLinecap="round"
//               />
//               <path
//                 d="M8 2.5H10V4.5"
//                 stroke="#555"
//                 strokeWidth="1.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </button>
//         </div>

//         {/* Input field */}
//         <input
//           type="text"
//           maxLength={4}
//           placeholder="Enter code"
//           value={input}
//           onChange={(e) => {
//             setInput(e.target.value.toUpperCase());
//             setError("");
//             setSuccess(false);
//           }}
//           onKeyDown={(e) => e.key === "Enter" && validate()}
//           style={{
//             ...styles.input,
//             borderColor: error ? "red" : success ? "green" : "#ccc",
//           }}
//         />

//         {/* Verify button */}
//         <button
//           type="button"
//           onClick={validate}
//           style={styles.validateBtn}
//         >
//           Verify
//         </button>

//       </div>

//       {/* Error message */}
//       {error && <p style={styles.error}>❌ {error}</p>}

//       {/* Success message */}
//       {success && <p style={styles.successMsg}>✅ Verified successfully!</p>}

//     </div>
//   );
// }

// const styles = {
//   wrapper: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "6px",
//     marginBottom: "12px",
//   },
//   row: {
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//     gap: "10px",
//     flexWrap: "wrap",
//   },
//   codeBox: {
//     display: "flex",
//     flexDirection: "row",
//     alignItems: "center",
//     gap: "8px",
//     backgroundColor: "#f0f0f0",
//     border: "1px dashed #aaa",
//     borderRadius: "6px",
//     padding: "6px 12px",
//   },
//   codeText: {
//     fontSize: "22px",
//     fontWeight: "bold",
//     letterSpacing: "8px",
//     fontFamily: "monospace",
//     color: "#222",
//     userSelect: "none",
//     textDecoration: "line-through",
//     textDecorationColor: "#aaa",
//   },
//   refreshBtn: {
//     background: "none",
//     border: "none",
//     cursor: "pointer",
//     padding: "2px",
//     display: "flex",
//     alignItems: "center",
//   },
//   input: {
//     padding: "12px 12px",
//     fontSize: "15px",
//     border: "2px solid #ccc",
//     borderRadius: "6px",
//     width: "150px",
//     letterSpacing: "3px",
//     textTransform: "uppercase",
//     outline: "none",
//     textAlign: "center",
//   },
//   validateBtn: {
//     padding: "10px 20px",
//     backgroundColor: "#ffc107",
//     color: "#000",
//     fontWeight: "bold",
//     border: "none",
//     borderRadius: "3px",
//     cursor: "pointer",
//     fontSize: "14px",
//     whiteSpace: "nowrap",
//     marginTop:"-3px"
//   },
//   error: {
//     color: "red",
//     fontSize: "12px",
//     margin: "0",
//   },
//   successMsg: {
//     color: "green",
//     fontSize: "12px",
//     margin: "0",
//   },
// };


import { useState, useCallback } from "react";

// Generate random 4-digit alphanumeric string
const generateCode = () => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let code = "";
  for (let i = 0; i < 4; i++) {
    code += chars[Math.floor(Math.random() * chars.length)];
  }
  return code;
};

export function Captcha({ onVerified }) {
  const [code, setCode]     = useState(() => generateCode());
  const [input, setInput]   = useState("");
  const [error, setError]   = useState("");
  const [success, setSuccess] = useState(false);

  const refresh = useCallback(() => {
    setCode(generateCode());
    setInput("");
    setError("");
    setSuccess(false);
    onVerified?.(false);
  }, [onVerified]);

  const validate = () => {
    if (!input) {
      setError("Please enter the code.");
      return;
    }
    if (input.toUpperCase() === code) {
      setError("");
      setSuccess(true);
      onVerified?.(true);
    } else {
      setError("Invalid code. Please try again.");
      setSuccess(false);
      onVerified?.(false);
      setCode(generateCode());
      setInput("");
    }
  };

  return (
    <div style={styles.wrapper}>

      {/* CAPTCHA code box + input + verify all in one flex row */}
      <div style={styles.row}>

        {/* Code display box */}
        <div style={styles.codeBox}>
          <span style={styles.codeText}>{code}</span>
          <button
            type="button"
            onClick={refresh}
            style={styles.refreshBtn}
            title="Refresh CAPTCHA"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 2.5A5 5 0 1 0 11 6"
                stroke="#555"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M8 2.5H10V4.5"
                stroke="#555"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Input field */}
        <input
          type="text"
          maxLength={4}
          placeholder="Enter code"
          value={input}
          onChange={(e) => {
            setInput(e.target.value.toUpperCase());
            setError("");
            setSuccess(false);
          }}
          onKeyDown={(e) => e.key === "Enter" && validate()}
          style={{
            ...styles.input,
            borderColor: error ? "red" : success ? "green" : "#ccc",
          }}
        />

        {/* Verify button */}
        <button
          type="button"
          onClick={validate}
          style={styles.validateBtn}
        >
          Verify
        </button>

      </div>

      {/* Error message */}
      {error && <p style={styles.error}>❌ {error}</p>}

      {/* Success message */}
      {success && <p style={styles.successMsg}>✅ Verified successfully!</p>}

    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    marginBottom: "12px",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  codeBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "7px",
    backgroundColor: "#f0f0f0",
    border: "1px dashed #aaa",
    borderRadius: "6px",
    padding: "1px 6px",
  },
  codeText: {
    fontSize: "20px",
    fontWeight: "bold",
    letterSpacing: "8px",
    fontFamily: "monospace",
    color: "#222",
    userSelect: "none",
    textDecoration: "line-through",
    textDecorationColor: "#aaa",
  },
  refreshBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "2px",
    display: "flex",
    alignItems: "center",
  },
  input: {
    padding: "8px 6px",
    fontSize: "15px",
    border: "2px solid #ccc",
    borderRadius: "6px",
    width: "140px",
    letterSpacing: "3px",
    textTransform: "uppercase",
    outline: "none",
    textAlign: "center",
  },
  validateBtn: {
    padding: "10px 15px",
    backgroundColor: "#ffc107",
    color: "#000",
    fontWeight: "bold",
    border: "none",
    borderRadius: "3px",
    cursor: "pointer",
    fontSize: "14px",
    whiteSpace: "nowrap",
    marginTop:"-3px"
  },
  error: {
    color: "red",
    fontSize: "12px",
    margin: "0",
  },
  successMsg: {
    color: "green",
    fontSize: "12px",
    margin: "0",
  },
};